module.exports = __webpack_public_path__ + "img/144.9.651b3201.png";